<template>
  <div class="buttonsTooltip-block">
    <!-- Button send new File -->
    <ButtonTooltipWithInput
      :indexName="indexName"
      :disabled="disabled"
      :uploadLoading="uploadLoading"
      :hasFile="hasFile"
      v-on="$listeners"
    />

    <!-- Button view File -->
    <ButtonTooltipView :indexName="indexName" :disabled="disabled || !hasFile || uploadLoading" />

    <!-- Button download File -->
    <ButtonTooltipDownload :indexName="indexName" :disabled="disabled || !hasFile || uploadLoading" />

    <!-- Button delete File -->
    <ButtonTooltipDelete :indexName="indexName" :disabled="disabled || !hasFile || uploadLoading" v-on="$listeners" />
  </div>
</template>

<script>
import ButtonTooltipWithInput from '@/components/adminVideo/ButtonTooltipWithInput'
import ButtonTooltipDownload from '@/components/adminVideo/ButtonTooltipDownload'
import ButtonTooltipDelete from '@/components/adminVideo/ButtonTooltipDelete'
import ButtonTooltipView from '@/components/adminVideo/ButtonTooltipView'

export default {
  name: 'ButtonsTooltip',

  components: {
    ButtonTooltipDownload,
    ButtonTooltipWithInput,
    ButtonTooltipDelete,
    ButtonTooltipView
  },

  props: {
    indexName: String,
    hasFile: Boolean,
    disabled: Boolean,
    uploadLoading: Boolean
  }
}
</script>

<style lang="sass" scoped>
.buttonsTooltip-block
  display: flex
  flex-wrap: nowrap
  @media screen and (min-width: 380px)
    justify-content: flex-end
</style>
